import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { TabbedLayout } from '../../../components';
import { useAuth } from '../../authentication';
import { useOrganizations, useUsers } from '../providers';
import { useConversations, useSpaces } from '../../chats/providers';

const OrganizationManagement = () => {
  const auth = useAuth();
  const { organizations, currentOrganization, selectOrganization } = useOrganizations();
  const { groupedConversations, fetchNextConversationsPage } = useConversations();
  const { currentUser, users } = useUsers();
  const { spaces } = useSpaces();

  const isAdmin = useMemo(
    () =>
      currentUser.memberships
        .find((membership) => membership.organizationId === currentOrganization.id)
        ?.entitlements.some((entitlement) => entitlement.role.name.toLowerCase() === 'admin'),
    [currentUser, currentOrganization.id]
  );

  return (
    <TabbedLayout
      user={currentUser}
      logout={auth.logout}
      organizations={organizations}
      selectOrganization={selectOrganization}
      currentOrganization={currentOrganization}
      users={users}
      groupedConversations={groupedConversations}
      spaces={spaces}
      fetchNextConversationsPage={fetchNextConversationsPage}
      tabs={[
        {
          component: 'Organization',
          title: 'Organization',
          path: '/organization/settings',
          icon: 'store'
        },
        { component: 'People', title: 'People', path: '/organization/people', icon: 'user' },
        {
          component: 'Data Warehouse',
          title: 'Data Warehouse',
          path: '/organization/data-warehouse',
          icon: 'table'
        },
        { component: 'Sources', title: 'Sources', path: '/organization/sources', icon: 'source' },
        {
          component: 'Business Logic',
          title: 'Business Logic',
          path: '/organization/business-logic',
          icon: 'insight'
        },
        ...(isAdmin
          ? [
              {
                component: 'QuestionReview',
                title: 'Question Review',
                path: '/organization/question-review',
                icon: 'qa'
              }
            ]
          : [])
      ]}
    >
      <Outlet />
    </TabbedLayout>
  );
};

export { OrganizationManagement };
